import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { filterErrorHandler } from "../../hoc/Shared/utility";

import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import MemberReferralListing from "./MemberReferralListing";
import MemberReferralDetail from "./MemberReferralDetail";

import { getMemberReferral } from "../../store/ducks/memberReferral/actions";
import moment from "moment";

const initialState = {
    username: '',
    referral_code: '',
    date: [],
}

class MemberReferral extends Component {
    constructor(props){
        super(props);
        this.state = {
            loading: true,
            data: [],
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            totalPages: 0,
            order: null,
            totalRecords: 0,
            searchValue: "",
            pageShow: "listing",
            errMsg: [],
            touched: false,
            filterInput: initialState,
            detailsParam: {},
            filter_action: '',
            alternateCol: false
        }
    }

    componentDidMount(){
        let data = this.getFilterList();
        this.props.getMemberReferral(data);
    }

    shouldComponentUpdate(nextProps, nextState){
        if(nextProps.member_referral_data !== undefined && nextProps.member_referral_data !== this.props.member_referral_data){
            if(nextProps.member_referral_data.data.responseCode === 200 && nextProps.member_referral_data.data.msgType === "success"){
                this.setState({
                    loading: false,
                    data: nextProps.member_referral_data.data.data.result.row,
                    alternateCol: nextProps.member_referral_data.data.data.alternateCol,
                    totalPages: nextProps.member_referral_data.data.data.result.pagination.total_page,
                    totalRecords: nextProps.member_referral_data.data.data.result.pagination.total_record,
                });
            }
            else{
                this.setState({
                    loading: false,
                    data: [],
                    totalPages: 0,
                    totalRecords: 0
                }, () => {
                    filterErrorHandler(nextProps.member_referral_data.data.message);
                });
            }
        }

        return true;
    }

    getFilterList = () => {
        const data = {}
        let availablePage = this.state.activePage;
        if(this.state.totalRecords > 0){
            availablePage = parseInt((this.state.totalRecords / this.state.limit) + 1);
            this.state.activePage >= availablePage && this.setState({ activePage: availablePage });
        }
        data.page = this.state.activePage >= availablePage ? availablePage : this.state.activePage;
        data.limit = this.state.limit;
        data.search = this.state.searchValue;
        data.order = JSON.stringify(this.state.order);
        data.username = this.state.filterInput.username;
        data.country_id = this.props.currentUser.country_id;
        data.referral_code = this.state.filterInput.referral_code;
        data.filter_action = this.state.filter_action;
        Object.keys(this.state.filterInput).forEach((val) => {
            data[val] = ((val==='start_date' || val==='end_date') && this.state.filterInput[val]!=='') ? moment(this.state.filterInput[val]).format("YYYY-MM-DD HH:mm:ss") : this.state.filterInput[val];
        });
        return data;
    }

    refreshHandler = () => {
        this.setState({
            errMsg: [],
            touched: false,
            loading: true,
            data: [],
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            order: null,
            filter_action: 'filter'
        }, ()=> {
            const data = this.getFilterList();
            this.props.getMemberReferral(data);
        });
    }

    clearHandler = () => {
        this.setState({
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: null,
            errMsg: [],
            touched: false,
            loading: true,
            data: [],
            filterInput: initialState,
            filter_action: ''
        }, ()=> {
            const data = this.getFilterList();
            this.props.getMemberReferral(data);
        });
    }

    onInputChange = (event, inputType) => {
        let newFilter = Object.assign({}, this.state.filterInput);
        newFilter[event.target.id] = event.target.value;
        if(event.target.id==='date') {
            const date = (event.target.value!=='') ? event.target.value.split(" - ") : null;
            newFilter['start_date'] = (date) ? date[0] : '';
            newFilter['end_date'] = (date) ? date[1] : '';
        }

        this.setState({
            filterInput: newFilter
        });
    }

    datatablesChangeHandler = (val, act) => {
        // console.log('datatablesChangeHandler :'+val + ' | '+act);
        let search = "";
        search = (act==='searchValue') ? val.target.value : val;

        this.setState({
            [act]: search,
            loading: true,
            data: [],
            errMsg: [],
            touched: false
        }, () => {
            const data = this.getFilterList();
            this.props.getMemberReferral(data);
        });
    }

    onSort = (field, order) => {
        // console.log(field+' | '+order);
        const orderArry = [{}];
        let orderSequence = (order === 'asc') ? true : false ;

        orderArry[0]['id'] = field;
        orderArry[0]['desc'] = orderSequence;

        this.setState({
            order: orderArry,
            loading: true,
            data: [],
            errMsg: [],
            touched: false,
        }, () => {
            const data = this.getFilterList();
            this.props.getMemberReferral(data);
        });
    }

    changePageHandler = (page) => {
        this.setState({
            pageShow: page
        });
    }

    noFormatter = (cell, row, rowIndex) => {
        let rowNumber = (this.state.totalRecords - rowIndex - ((this.state.activePage - 1) * this.state.limit));
        return <span>{rowNumber}</span>;
    }

    detailsHandler = (e, id) => {
        e.preventDefault();
        this.setState({
            pageShow: 'details',
            detailsParam : {
                memberId: id,
                returnPage: 'listing',
                start_date: this.state.filterInput.start_date,
                end_date: this.state.filterInput.end_date,
                filter_action: this.state.filter_action
            }
        });
    }

    render(){
        const { t } = this.props;
        const columns = !this.state.alternateCol? [
            { text: t("global.no"), dataField: "no", formatter: this.noFormatter, headerStyle: { width: "60px", textAlign: "center" } },
            { text: t("member-referral.member-username"), dataField: "username", sort: true, onSort: this.onSort },
            { text: t("member-referral.referral-code"), dataField: "referral_code", sort: true, onSort: this.onSort },
            { text: t("member-referral.total-click"), dataField: "total_visit", sort: true, onSort: this.onSort },
            { text: t("member-referral.unique-click"), dataField: "unique_visit", sort: true, onSort: this.onSort },
            { text: t("member-referral.total-referees"), dataField: "total_referee", sort: true, onSort: this.onSort },
            { text: t("member-referral.total-fdp"), dataField: "total_fdp", sort: true, onSort: this.onSort },
            { text: t("member-referral.last-referred"), dataField: "last_referred", sort: true, onSort: this.onSort }
        ] : [
            { text: t("global.no"), dataField: "no", formatter: this.noFormatter, headerStyle: { width: "60px", textAlign: "center" } },
            { text: t("member-referral.member-username"), dataField: "username", sort: true, onSort: this.onSort },
            { text: t("member-referral.referral-code"), dataField: "referral_code", sort: true, onSort: this.onSort },
            { text: t("member-referral.total-referees"), dataField: "total_referee", sort: true, onSort: this.onSort },
            { text: t("member-referral.total-fdp"), dataField: "total_fdp", sort: true, onSort: this.onSort },
            { text: t("member-referral.last-referred"), dataField: "last_referred", sort: true, onSort: this.onSort }
        ] ;

        let data = this.state.data.map((val, idx) => {
            let total_referee = (<b>
                <a href="/#" onClick={(event) => this.detailsHandler(event, val.id)}>
                    {val.total_referee}
                    <i className="fas fa-external-link-square-alt text-primary ml-1"></i>
                </a>
            </b>);
            return {
                no: idx,
                username: val.username,
                referral_code: val.referral_code,
                total_visit: val.total_visit,
                unique_visit: val.unique_visit,
                total_referee: total_referee,
                total_fdp: val.total_fdp,
                last_referred: val.last_referred
            }
        });

        return (
            <Auxiliary>
                {this.state.pageShow === "listing" && 
                <MemberReferralListing 
                    refreshHandler={() => this.refreshHandler()}
                    clearHandler={() => this.clearHandler()}
                    onInputChange={(event, inputType) => this.onInputChange(event, inputType)}
                    datatablesChangeHandler={(val, act) => this.datatablesChangeHandler(val, act)}
                    onSort={(field, order) => this.onSort(field, order)}

                    data={data}
                    columns={columns}
                    touched={this.state.touched}
                    errMsg={this.state.errMsg}
                    currentUser={this.props.currentUser}
                    loading={this.state.loading}
                    filterInput={this.state.filterInput}
                    activePage={this.state.activePage}
                    limit={this.state.limit}
                    totalRecords={this.state.totalRecords}
                    searchValue={this.state.searchValue}
                />
                }

                {this.state.pageShow === "details" &&
                <MemberReferralDetail 
                    detailsParam={this.state.detailsParam}
                    changePageHandler={(page) => this.changePageHandler(page)}
                />
                }
            </Auxiliary>
        )
    }
}

const mapStateToProps = state => {
    return {
        member_referral_data: state.memberReferral.member_referral_data,
        currentUser: state.currentUser.data
    }
}

const mapDispatchToProps = {
    getMemberReferral
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(MemberReferral));